var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminDashboardIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5232 9.75272C20.8841 5.81932 17.5431 2.89308 13.5598 2.77789C13.3704 2.77047 13.1858 2.83866 13.0467 2.96743C12.9077 3.0962 12.8255 3.27499 12.8184 3.46439V3.52846L13.2669 10.2378C13.2963 10.6895 13.6846 11.0328 14.1364 11.0067L20.8641 10.5582C21.0537 10.5442 21.2298 10.4552 21.3536 10.3108C21.4773 10.1665 21.5383 9.97882 21.5232 9.78933V9.75272Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90102 6.76877C9.32898 6.66978 9.76692 6.88875 9.9445 7.29051C9.99102 7.385 10.019 7.48754 10.0269 7.59257C10.1184 8.89234 10.3106 11.739 10.4205 13.2768C10.4392 13.5538 10.5676 13.8119 10.7772 13.994C10.9868 14.1761 11.2603 14.2671 11.5372 14.247L17.1848 13.8992C17.4369 13.884 17.6841 13.9738 17.8678 14.1471C18.0515 14.3204 18.1555 14.562 18.155 14.8145C17.9262 18.2249 15.4759 21.0759 12.1387 21.815C8.80153 22.554 5.37669 21.0039 3.7294 18.009C3.23765 17.1471 2.92623 16.1941 2.81406 15.2081C2.76611 14.9055 2.74772 14.599 2.75914 14.2928C2.76886 10.6508 5.32665 7.51273 8.89187 6.76877",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90102 6.76877C9.32898 6.66978 9.76692 6.88875 9.9445 7.29051C9.99102 7.385 10.019 7.48754 10.0269 7.59257C10.1184 8.89234 10.3106 11.739 10.4205 13.2768C10.4392 13.5538 10.5676 13.8119 10.7772 13.994C10.9868 14.1761 11.2603 14.2671 11.5372 14.247V14.247L17.1848 13.8992C17.4369 13.884 17.6841 13.9738 17.8678 14.1471C18.0515 14.3204 18.1555 14.562 18.155 14.8145V14.8145C17.9262 18.2249 15.4759 21.0759 12.1387 21.815C8.80153 22.554 5.37669 21.0039 3.7294 18.009C3.23765 17.1471 2.92623 16.1941 2.81406 15.2081C2.76611 14.9055 2.74772 14.599 2.75914 14.2928C2.76886 10.6508 5.32665 7.51273 8.89187 6.76877",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDashboardIconFilled);
export default __webpack_public_path__ + "static/media/admin-dashboard-icon-filled.4f5f8b496f23b10b4b8d899c012d25bb.svg";
export { ForwardRef as ReactComponent };